import _ from 'lodash';

import appConfig from '@nerdwallet/app-config';
import { CORE_HTTP_HEADERS } from '@nerdwallet/nw-api-sdk/headers';

import { nwFetch } from '../fetch';

const ALPS_URL = `${appConfig.API.BASE_URLS.ALPS}/product_ordering/v1/displayed_product_ordering`;

/**
 * Fetch the order of marketpace entity ids from ALPS.
 * @private - Exported for testing
 *
 * @param {Object} options
 * @param {Array} [options.defaultIds]
 * @param {Object} [options.logger]
 * @param {String} options.productPage
 * @param {String} options.productType
 * @param {String} options.productType
 * @param {Object} options.req
 */
const fetchAlpsMarketplaceEntityIdOrdering = async ({
  defaultIds = [],
  logger,
  productPage,
  productType,
  req,
}) => {
  const userAgent =
    req &&
    (req.get(CORE_HTTP_HEADERS.USER_AGENT) ||
      req.get(CORE_HTTP_HEADERS.X_ORIGINATING_USER_AGENT));
  try {
    const response = await nwFetch({
      url: ALPS_URL,
      params: { product_type: productType, product_page: productPage },
      serverRequest: req,
      /**
       * @todo ALPS expects the "User-Agent" header specifically.
       * @see {@link https://github.com/NerdWallet/alps/issues/121}
       */
      headers: userAgent && { [CORE_HTTP_HEADERS.USER_AGENT]: userAgent },
    });

    const productIdsAlpsOrdered = _.get(
      response,
      ['data', 0, 'product_id_order'],
      []
    );
    const modelExecutionIds = _.get(response, ['meta', 'model_execution_ids']);
    const resultSizeLimit = response?.data?.[0]?.result_size_limit;
    if (!productIdsAlpsOrdered.length) {
      throw new Error('Invalid response from ALPS');
    }
    return {
      ids: productIdsAlpsOrdered,
      modelExecutionIds,
      resultSizeLimit,
    };
  } catch (err) {
    if (logger) {
      logger.warn(
        `[ALPS ${_.startCase(
          productType
        )}] ERROR: Could not fetch ALPS ordering data for "${productPage}". Falling back to default product ordering.`,
        JSON.stringify(err)
      );
    }
    return { ids: defaultIds };
  }
};

export default fetchAlpsMarketplaceEntityIdOrdering;
